module.exports = __webpack_public_path__ + "img/africa-inc-grey.d3a25689.png";